
import AppCustomLanguageSelect from "@/components/sale-layout-editor/CustomLanguageSelectWithCopy.vue";
import { DocumentLayoutHeading } from "@/utils/documents/layout-heading";
import { TranslatedStyledProperty } from "@/utils/documents/translated-styled-property";
import Vue from "vue";
import AppStyleEditor from "./StyleEditor.vue";
import { LanguagesConfig } from "@/models/dossier-configs/languages";
import { DossierConfigService } from "@/services/dossier-config-service";
import { ISelectItem } from "winfakt-vue-components";
import AppAllLayoutsSelect from "./AllLayoutsSelect.vue";
import { SaleLayoutInfo } from "@/utils/sale-layouts/sale-layout-info";
import { DocumentLayoutInfo } from "@/utils/documents/layout-info";
import { ReminderService, SaleService } from "@/services";
import AppConditionsEditModal from "./ConditionsEditModal.vue";
import { PropSelectGroup } from "@/utils/prop-select/prop-select-group";

export default Vue.extend({
	data() {
		return {
			toEditStyleHeading: null as null | TranslatedStyledProperty,
			headingItems: [] as TranslatedStyledProperty[],
			allLayoutsSelectModalOpen: false,
			conditionsEditModalOpen: false
		};
	},
	props: {
		heading: {
			type: Object as () => DocumentLayoutHeading,
			required: true
		},
		lang: String,
		showResetButton: Boolean,
		fields: {
			type: Object as ()=> PropSelectGroup
		}
	},
	computed: {
		languages(): LanguagesConfig {
			return DossierConfigService.getLanguages();
		},
		buttonBarItems():ISelectItem<Function>[]{
			let result:ISelectItem<Function>[] = [
				{
					text: this.$ct("convert-to-free-block"),
					value: this.convertToFreeBlock,
					disabled: !this.heading.Show
				},
				{
					text: this.$ct("apply-heading-to-other-layouts"),
					value: this.openApplyToOtherLayoutsModal
				}
			] as ISelectItem<Function>[];
			if (this.fields){
				result.push({
					text: this.$ct("edit-conditions"),
					value: ()=>this.conditionsEditModalOpen = true
				});
			}
			if  (this.showResetButton) {
				result.push({
					text: this.$ct("reset-to-default"),
					value: this.resetToDefaultSettings
				});
			}
			return result;
		}
	},
	methods: {
		convertToFreeBlock(){
			this.$emit("convert-to-free-block");
		},
		editStyle(style: TranslatedStyledProperty) {
			this.toEditStyleHeading = style;
		},
		setLang(lang: string) {
			this.$emit("update:lang", lang);
		},
		onSorted() {
			this.heading.Heading1 = this.headingItems[0];
			this.heading.Heading2 = this.headingItems[1];
			this.heading.Heading3 = this.headingItems[2];
			this.heading.Heading4 = this.headingItems[3];
			this.heading.Heading5 = this.headingItems[4];
			this.heading.Heading6 = this.headingItems[5];
			this.heading.Heading7 = this.headingItems[6];
			this.heading.Heading8 = this.headingItems[7];
			this.heading.Heading9 = this.headingItems[8];
		},
		copyToAllLanguages() {
			for (let v of this.headingItems) {
				let x = v.Value.Translations["nl-be"];
				for (let l of this.languages.LanguageNames) {
					v.Value.Translations[l] = x;
				}
			}
		},
		resetToDefaultSettings(){
			this.$emit("reset-to-default");
		},
		openApplyToOtherLayoutsModal(){
			this.allLayoutsSelectModalOpen = true;
		},
		async applyHeadingToSaleLayouts(layouts:SaleLayoutInfo[]){
			await SaleService.applyHeadingToLayouts(layouts, this.heading);
		},
		async applyHeadingToReminderLayouts(layouts:DocumentLayoutInfo[]){
			await ReminderService.applyHeadingToLayouts(layouts, this.heading);
		},
		async applyHeadingToOtherLayoutsHandler(saleLayouts:SaleLayoutInfo[], reminderLayouts:DocumentLayoutInfo[]) {
			if (saleLayouts.length > 0){
				await this.applyHeadingToSaleLayouts(saleLayouts);
			}
			if (reminderLayouts.length > 0){
				await this.applyHeadingToReminderLayouts(reminderLayouts);
			}
			this.$wf.notify(this.$ct("common.success"), "success", 3000, "check");
			this.allLayoutsSelectModalOpen = false;
		}
	},
	mounted() {
		this.headingItems = [
			this.heading.Heading1,
			this.heading.Heading2,
			this.heading.Heading3,
			this.heading.Heading4,
			this.heading.Heading5,
			this.heading.Heading6,
			this.heading.Heading7,
			this.heading.Heading8,
			this.heading.Heading9
		];
	},
	components: {
		AppCustomLanguageSelect,
		AppStyleEditor,
		AppAllLayoutsSelect,
		AppConditionsEditModal
	},
	i18nEx: {
		componentPrefix: "components.layout-editor"
	}
});
